export const STUDENT_HOME =
    process.env.NODE_ENV === 'development'
        ? 'https://learning-devci.poc.learning.amplify.com/'
        : 'https://learning.amplify.com';

export const SEB_URL = '/seb-server/v1/seb_config.seb?application_id=student_assessment';

export const AUTH_TOKEN = 'auth_token';

export const REFRESH_TOKEN = 'refresh_token';

export const SEB_AUTH_URL = '/seb-server/v1/authenticate_keycloak_user';
